import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-[60vh] grid place-items-center text-slate-500">Loading…</div>;
  }
  if (!user) {
    return <Navigate to={adminOnly ? "/admin" : "/signin"} state={{ from: location.pathname }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/admin" replace />;
  }
  return children;
};
